<template>
  <v-dialog v-model="show" max-width="500">
    <v-card>
      <v-card-title>Remove Trade</v-card-title>
      <v-card-text>
        <span class="text-h6">
          Are you sure to remove
          <span class="primary--text">{{ template.label }}</span>
        </span>
        <br />
        <span class="red--text text-subtitle-2">
          This action <b>CANNOT BE UNDONE</b>
        </span>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          @click="onRemoveTemplate(tradeId, templateId)"
          color="red"
          class="white--text px-10"
          :loading="false"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import eventBus from '@/services/eventBus'

export default {
  name: 'RemoveTemplateDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    trade: {
      type: Object,
    },
    template: {
      type: Object,
    },
  },

  data() {
    return {
      show: this.value,
      tradeId: this.trade.id,
      templateId: this.template.id,
    }
  },

  methods: {
    ...mapActions({
      removeTemplate: 'trade/removeTemplate',
    }),

    async onRemoveTemplate(tradeId, templateId) {
      await this.removeTemplate({ id: tradeId, templateId: templateId })
        .then((res) => {
          this.$emit('onTemplateRemoved')
          eventBus.$emit('snackbar', {
            message: 'Required File removed successfully!',
            color: 'success',
          })
        })
        .catch((err) => {
          eventBus.$emit('snackbar', {
            message: err.data.message,
            color: 'red',
          })
        })
    },
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)
    },

    trade(val) {
      this.tradeId = val.id
    },

    template(val) {
      this.templateId = val.id
    },
  },
}
</script>
